import { Button, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Modal from "../../../components/safe-modal/SafeModal.jsx";
function Table({toggle,setToggle,data=[]}) {
    return ( 
        <Modal isOpen={toggle} backdrop="static"   centered={true}  size="sm ">
            <ModalHeader toggle={()=>setToggle()}></ModalHeader>
                    <ModalBody>
                    <div className="table-responsive">
                    {toggle &&  <table className="table table-sm">
                        <thead>
                            <tr>
                                <th>Codigo </th>
                                <th>Nombre</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item)=>(
                            <tr key={item.sellerCode}>
                                
                                <td>{item.sellerCode}</td>
                                <td>{item.sellerName}</td>
                            </tr>
                            ))}
                        </tbody>
                    </table>}
                </div>
                </ModalBody>
                
                <ModalFooter>
                
                <Button color="secondary" onClick={()=>setToggle()}>
                    Cerrar
                </Button>
                </ModalFooter>
        </Modal>
     );
}

export default Table;